import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const TechnologyPartnersListForNRO = lazy(() =>
  import("@scenes/TechnologyPartners/TechnologyPartnersList").then((module) => ({
    default: module.TechnologyPartnersList,
  }))
);

export const technologyPartnersListNRO: NavigationRoutingObject = {
  section: "partner-integrations",
  Component: TechnologyPartnersListForNRO,
  noKnockoutFallback: true,
  componentFeatureFlippers: [],
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("technology-partners-sidebar-pill-menu-option", "Technology Partners"),
  description: (t: I18nT<"dashboard-navigation">) =>
    t(
      "partner-integrations-description-nav",
      "View our partners and connect Braze to the technologies your team uses"
    ),
  icon: "nav-system-technology-partners",
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
